module.exports = __webpack_public_path__ + "static/media/huoshishan_package.38d5733d.png";